import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Container, Box } from "@mui/material";
import Layout from "../../../layout/Layout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addGeneralInformation,
  getGeneralInformation,
  editGeneralInformation,
} from "../../../services/coworking/generalInformationAPI";

const AddEditCoworkingGeneralInformation = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  let location = useLocation();
  location = location.pathname.slice(1);

  const isEditMode =
    location === "add-new-coworking-general-information" ? false : true;

  const [generalInfoData, setGeneralInfoData] = useState({
    icon: "",
    iconAltText: "",
    title: "",
  });

  useEffect(() => {
    if (id) {
      getGeneralInformation(id)
        .then((data) => {
          setGeneralInfoData({
            icon: data.icon,
            iconAltText: data.icon_alt_text,
            title: data.title,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGeneralInfoData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const newGeneralInfoData = {
      icon: generalInfoData.icon,
      icon_alt_text: generalInfoData.iconAltText,
      title: generalInfoData.title,
    };
    if (isEditMode) {
      editGeneralInformation(id, newGeneralInfoData)
        .then((response) => {
          setGeneralInfoData({
            icon: "",
            iconAltText: "",
            title: "",
          });

          navigate("/coworking-general-information");
        })
        .catch((error) => {
          console.error("Greška pri ažuriranju:", error);
        });
    } else {
      addGeneralInformation(newGeneralInfoData)
        .then((response) => {
          setGeneralInfoData({
            ...generalInfoData,
            icon: response.icon,
            iconAltText: response.icon_alt_text,
            title: response.title,
          });
          navigate("/coworking-general-information");
        })
        .catch((error) => {
          console.error("Greška pri dodavanju", error);
        });
    }
  };
  const handleBack = () => {
    // Handle Back action here
  };

  return (
    <Layout>
      <div>
        <Box style={{ display: "flex" }}>
          <Link
            to="/coworking-general-information"
            style={{ textDecoration: "none" }}
          >
            <Button variant="outlined" onClick={handleBack}>
              <ArrowBackIcon />
              Back
            </Button>
          </Link>
        </Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
          Coworking General Information
        </Typography>

        <form onSubmit={handleSubmit}>
          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="icon"
              label="Icon"
              value={generalInfoData.icon}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="iconAltText"
              label="Icon Alt Text"
              value={generalInfoData.iconAltText}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="title"
              label="Title"
              value={generalInfoData.title}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <Container
            sx={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              sx={{ m: 1, width: "25ch" }}
              type="submit"
              size="medium"
              variant="outlined"
            >
              {location === "add-new-coworking-general-information"
                ? "Publish"
                : "Save"}
            </Button>
          </Container>
        </form>
      </div>
    </Layout>
  );
};

export default AddEditCoworkingGeneralInformation;
